export default __webpack_public_path__ + "static/flowers-15cccb932ab6417a9a7a847d88e051ee.png";